<script>
    import { blur } from 'svelte/transition';
    import { quintIn } from 'svelte/easing';

    export let isSubmissionError;
</script>

{#if isSubmissionError}
    <div class="d-flex error" in:blur="{{ duration: 500, delay: 400, easing: quintIn }}">
        <div class="p-relative error__img">
            <svg version="1.1" class="svg_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                    <path class="fill_black" d="M2310,5114c-447-54-825-190-1167-420c-164-110-255-185-393-324c-139-138-214-229-324-393
                        C222,3675,86,3326,23,2945c-26-158-26-612,0-770c63-381,199-730,403-1032c110-164,185-255,324-393c138-139,229-214,393-324
                        c302-204,651-340,1032-403c88-14,166-18,385-18s297,4,385,18c381,63,730,199,1032,403c164,110,255,185,393,324
                        c139,138,214,229,324,393c204,302,340,651,403,1032c26,158,26,612,0,770c-63,381-199,730-403,1032c-110,164-185,255-324,393
                        c-138,139-229,214-393,324c-295,199-631,332-1002,398c-85,15-169,20-370,23C2462,5116,2329,5116,2310,5114z M2810,3075v-765h-250
                        h-250v765v765h250h250V3075z M2810,1535v-255h-250h-250v255v255h250h250V1535z"/>
                </g>
            </svg>
        </div>
        <h3>Something went wrong, try later</h3>  
    </div>
{:else}
    <div class="d-flex success" in:blur="{{ duration: 500, delay: 400, easing: quintIn }}">
        <div class="p-relative success__img">
            <svg version="1.1" class="svg_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                    <path class="fill_black" d="M2305,5114c-280-40-429-74-615-141c-264-94-559-264-770-441c-485-408-792-950-897-1587c-26-158-26-612,0-770
                        c45-273,121-514,238-751C586,763,1197,265,1906,80c243-63,340-74,649-75c225,0,302,4,390,18c575,95,1060,346,1456,753
                        c374,386,606,851,696,1399c14,87,18,167,18,385c0,301-9,381-67,620c-82,339-258,699-478,975c-341,428-837,751-1358,886
                        c-229,59-333,71-617,74C2452,5117,2322,5116,2305,5114z M3700,3405l215-215l-848-848l-847-847l-505,505l-505,505l217,217l218,218
                        l287-287l288-288l628,628c345,345,629,627,632,627S3582,3523,3700,3405z"/>
                </g>
            </svg>
        </div>
        
        <h3>Your message has been sent</h3>  
    </div>
{/if}

<style lang="scss">
    .success, .error{
        margin-top: 5rem;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        &__img{
            max-width: 120px;
            margin-bottom: 1.5rem;
            > svg {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>